import React from 'react';
import Typography from '@mui/material/Typography';
import { Box, Stack } from '@mui/material';
export default function Footer() {
  return (
    <Box mt="20px">
      <Stack alignItems="center">
        <Typography variant="h5" color="initial">
          Rajaaaat 🐍🐍
        </Typography>
      </Stack>
    </Box>
  );
}
